import type {Pointer} from '@wix/document-services-types'
import {addPageIdFromPointer} from './transformerUtils'

const transformSet = (pointer: Pointer, value: any) => ({value: addPageIdFromPointer(pointer, value), pointer})

export {transformSet}
